import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { US_PHONE_FORMAT } from "../constants";

const getRecaptcha = (action) => {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY, {
          action: action,
        })
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

const getBrowserFingerprint = () => {
  // Get the visitor identifier when you need it.
  return new Promise((resolve, reject) => {
    const fpPromise = FingerprintJS.load();
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        resolve(result.visitorId);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const saveRemoteConfig = (obj) => {
  localStorage.setItem("remoteConfig", JSON.stringify(obj));
};

const getRemoteConfig = () => {
  return localStorage.getItem("remoteConfig")
    ? JSON.parse(localStorage.getItem("remoteConfig"))
    : null;
};

const getParameterFromURL = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const countdown = (time, ref) => {
  let timer = time;
  const timeInterval = setInterval(() => {
    if (timer > 0) {
      timer--;
      const getSeconds = `0${timer % 60}`.slice(-2);
      const minutes = `${Math.floor(timer / 60)}`;
      const getMinutes = `0${minutes % 60}`.slice(-2);
      // const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

      ref.current.innerText = `${getMinutes}m ${getSeconds}s`;
    }
  }, 1000);

  return () => {
    clearInterval(timeInterval);
  };
};

const formatPhoneNumber = (value) => {
  let tempVal = "";
  const input = value.replace(/\D/g, "").substring(0, 10);
  const zip = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);
  if (input.length > 6) {
    tempVal = `(${zip}) ${middle}-${last}`;
  } else if (input.length > 3) {
    tempVal = `(${zip}) ${middle}`;
  } else if (input.length > 0) {
    tempVal = `(${zip}`;
  }
  return tempVal;
};

export const formatUsPhoneToString = (phone) => {
  const temp = ("" + phone).replace(/\D/g, "");
  return `+1${temp}`;
};

const validatePhone = (phone) => {
  let cleaned = ("" + phone).replace(/\D/g, "");

  const US_PHONE_FORMAT = /^(1|)?(\d{3})(\d{3})(\d{4})$/;

  const match = cleaned.match(US_PHONE_FORMAT);
  if (match) {
    return true;
  }
  return false;
};

export const NUMBER = /^[0-9]*$/;

const isRemittanceFlow = (location = {}) => {};

const formatCurrency = (number, formatType, formatDecimal = false) => {
  const hasDecimal = number.indexOf(".") > -1;
  if (!hasDecimal) {
    return new Intl.NumberFormat(formatType).format(number);
  }
  const [integerPortion, decimalPortion] = number.split(".");
  const formattedIntegerPortion = new Intl.NumberFormat(formatType).format(
    integerPortion
  );
  if (formatDecimal) {
    const decimal =
      decimalPortion?.length === 1 ? `${decimalPortion}0` : decimalPortion;
    return `${formattedIntegerPortion}.${decimal}`;
  }

  return `${formattedIntegerPortion}.${decimalPortion}`;
};

const format2Decimals = (number) => {
  if (number) {
    return Math.round(number * 100) / 100;
  }
  return number;
};

const isMobileDevice = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

const downloadApp = (type) => {
  let url = "";
  if (type === "iOS") {
    url = "https://abound.onelink.me/P9V6/remittanceweb";
  }
  if (type === "android") {
    url = "https://abound.onelink.me/P9V6/remittanceweb";
  }
  window.open(url, "_blank");
};

const formatUsNumber = (phone) => {
  let cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(US_PHONE_FORMAT);
  const isMatched = US_PHONE_FORMAT.test(cleaned);
  if (isMatched) {
    const formattedPhone = ["(", match[2], ") ", match[3], "-", match[4]].join(
      ""
    );

    return formattedPhone;
  } else {
    return "";
  }
};

const goToAbound = () => {
  window.open(process.env.REACT_APP_ABOUND_SITE, "_self");
};

export {
  getRecaptcha,
  getBrowserFingerprint,
  saveRemoteConfig,
  getRemoteConfig,
  getParameterFromURL,
  countdown,
  formatPhoneNumber,
  validatePhone,
  formatCurrency,
  format2Decimals,
  isMobileDevice,
  downloadApp,
  formatUsNumber,
  goToAbound,
};
